const HTTP_PREFIX = "http";
const PUBLIC_MARKER = "/storage/v1/object/public/";
const SIGN_MARKER = "/storage/v1/object/sign/";

const extractPathFromMarker = (
  pathname: string,
  marker: string,
  bucket?: string | null,
) => {
  const index = pathname.indexOf(marker);
  if (index === -1) return null;

  const rest = pathname.slice(index + marker.length);
  if (!rest) return null;

  if (bucket && rest.startsWith(`${bucket}/`)) {
    return rest.slice(bucket.length + 1);
  }

  const parts = rest.split("/").filter(Boolean);
  if (parts.length < 2) return null;

  return parts.slice(1).join("/");
};

export const normalizeStoragePath = (
  value?: string | null,
  bucket?: string | null,
) => {
  if (!value) return null;
  if (!value.startsWith(HTTP_PREFIX)) return value;

  try {
    const url = new URL(value);
    const { pathname } = url;
    const fromPublic = extractPathFromMarker(pathname, PUBLIC_MARKER, bucket);
    if (fromPublic) return fromPublic;

    const fromSign = extractPathFromMarker(pathname, SIGN_MARKER, bucket);
    if (fromSign) return fromSign;
  } catch {
    return value;
  }

  return value;
};
